export default {
  'role.query.roleName': 'Role Name',
  'role.query.roleName.placeholder': 'Enter role name',
  'role.column.roleName': 'Role Name',
  'role.column.description': 'Role Description',
  'role.column.roleKey': 'Permission String',
  'role.column.status': 'Status',
  'role.column.status.normal': 'Normal',
  'role.column.status.disable': 'Disabled',
  'role.button.roleMember': 'Assign Users',
  'role.button.dataScope': 'Data Permission',
  'role.importDialog.tip': 'Status field options: Normal, Disabled',
  // edit
  'role.edit.title': 'Edit Role',
  'role.edit.success': 'Successfully Modified',
  'role.add.title': 'Add Role',
  'role.add.success': 'Successfully Added',
  'role.edit.button.prev': 'Previous Step',
  'role.edit.button.next': 'Next Step',
  'role.edit.step.roleInfo': 'Role Information',
  'role.edit.step.funcPermission': 'Functional Permission',
  'role.edit.form.roleName': 'Role Name',
  'role.edit.form.roleName.placeholder': 'Please enter role name',
  'role.edit.form.roleName.required': 'Please enter role name',
  'role.edit.form.description': 'Description',
  'role.edit.form.description.placeholder': 'Please enter role description',
  'role.edit.form.roleKey': 'Permission',
  'role.edit.form.roleKey.placeholder': 'Please enter permission string',
  'role.edit.form.roleKey.required': 'Please enter permission string',
  'role.edit.form.status': 'Status',
  'role.edit.form.status.required': 'Please select role status',
  'role.edit.form.status.normal': 'Normal',
  'role.edit.form.status.disable': 'Disable',
  'role.edit.form.menuPermission': 'Menu Permission',
  'role.edit.form.menuPermission.expand': 'Expand/Collapse',
  'role.edit.form.menuPermission.checkedAll': 'Select All/Deselect All',
  'role.edit.form.menuPermission.checkStrictly': 'Parent-Child Linkage',
  'role.edit.form.menuPermission.filterKeyword': 'Enter keyword',
  'role.edit.form.menuPermission.emptyText': 'No Data',
  // role user drawer
  'role.userDrawer.title': 'Assign Users',
  'role.userDrawer.cancelAuthConfirm': 'Are you sure you want to cancel authorization for {length} records?',
  'role.userDrawer.cancelAuthConfirm.single': 'Are you sure you want to cancel authorization for user "{username}"?',
  'role.userDrawer.cancelAuthSuccess': 'Authorization Canceled Successfully',
  'role.userDrawer.query.nickname': 'User Name',
  'role.userDrawer.query.nickname.placeholder': 'Enter user name',
  'role.userDrawer.query.mobile': 'Mobile',
  'role.userDrawer.query.mobile.placeholder': 'Enter mobile',
  'role.userDrawer.button.addAuthUser': 'Add Authorized User',
  'role.userDrawer.button.batch.cancelAuth': 'Batch Cancel Authorization',
  'role.userDrawer.column.username': 'Login Name',
  'role.userDrawer.column.nickname': 'Nickname',
  'role.userDrawer.column.deptId': 'Department',
  'role.userDrawer.column.mobile': 'Mobile',
  'role.userDrawer.column.status': 'Status',
  'role.userDrawer.column.status.normal': 'Normal',
  'role.userDrawer.column.status.disable': 'Disabled',
  'role.userDrawer.column.lastActiveTime': 'Last Active Time',
  'role.userDrawer.button.cancelAuth.title': 'Cancel',
  // add auth user dialog
  'role.addAuthUserDialog.title': 'Add Authorized User',
  'role.addAuthUserDialog.confirm': 'Are you sure you want to assign roles to these {length} users?',
  'role.addAuthUserDialog.success': 'Authorization Successful',
  'role.addAuthUserDialog.query.nickname': 'User Name',
  'role.addAuthUserDialog.query.nickname.placeholder': 'Enter user name',
  'role.addAuthUserDialog.query.mobile': 'Mobile',
  'role.addAuthUserDialog.query.mobile.placeholder': 'Enter mobile',
  'role.addAuthUserDialog.button.batchAuth': 'Batch Authorization',
  'role.addAuthUserDialog.column.username': 'Login Name',
  'role.addAuthUserDialog.column.nickname': 'Nickname',
  'role.addAuthUserDialog.column.deptId': 'Department',
  'role.addAuthUserDialog.column.mobile': 'Mobile',
  'role.addAuthUserDialog.column.status': 'Status',
  'role.addAuthUserDialog.column.status.normal': 'Normal',
  'role.addAuthUserDialog.column.status.disable': 'Disabled',
  'role.addAuthUserDialog.column.lastActiveTime': 'Last Active Time',
  // data scope dialog
  'role.dataScopeDialog.title': 'Assign Data Permission',
  'role.dataScopeDialog.success': 'Successfully Assigned',
  'role.dataScopeDialog.form.dataScope': 'Permission Scope',
  'role.dataScopeDialog.form.dataScope.required': 'Please select permission scope',
  'role.dataScopeDialog.form.dataPermission': 'Data Permission',
  'role.dataScopeDialog.form.dataPermission.expand': 'Expand/Collapse',
  'role.dataScopeDialog.form.dataPermission.checkedAll': 'Select All/Deselect All',
  'role.dataScopeDialog.form.dataPermission.checkStrictly': 'Parent-Child Linkage',
  'role.dataScopeDialog.form.dataPermission.filterKeyword': 'Enter keyword to search',
  'role.dataScopeDialog.form.dataPermission.emptyText': 'No Data',
}
